<template>
  <div>
    <div class="info" v-if="!edit && !mover && !typer">
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      ></controls>

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
        <small class="has-text-grey-light">[{{ question.weight }}]</small>
      </h4>

      <div class="question-body" v-for="field in question.fields">
        <div class="question-field">
          <div class="columns">
            <div class="column is-1" v-if="question.dataType === 'dt_name'">
              <i class="fa fa-user" title="name"></i>
            </div>
            <div class="column is-1">{{ field.choice }}</div>
            <div class="column">
              <div class="field-placeholder">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
            />
            <span class="icon is-small is-right" v-if="errors['title']">
              <i class="fa fa-warning"></i>
            </span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Weight</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select name="weight" v-model="data['weight']">
              <option v-for="weight in weights" v-bind:value="weight.value"
                >[{{ weight.value }}] {{ weight.label }}</option
              >
            </select>
            <span class="icon is-small is-right" v-if="errors['title']">
              <i class="fa fa-warning"></i>
            </span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Required</label>
          <div class="control has-icons-right mt-2 select is-fullwidth">
            <select
              name="required"
              v-model="data['required']"
              :disabled="question.interviewMandatory"
            >
              <option v-for="required in yesNo" :value="required.value">{{
                required.label
              }}</option>
            </select>
            <span class="icon is-small is-right" v-if="errors['title']">
              <i class="fa fa-warning"></i>
            </span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field" v-for="(field, index) in data.fields">
          <label class="label">Label {{ index + 1 }}</label>
          <div class="columns">
            <div class="column">
              <div class="control field-options">
                <input
                  type="text"
                  :class="['input', { 'is-danger': errors[`choice${index}`] }]"
                  v-model="field['choice']"
                  name="title"
                  required
                />
                <span
                  class="icon is-small is-right"
                  v-if="errors[`choice${index}`]"
                >
                  <i class="fa fa-warning"></i>
                </span>
              </div>
              <p v-if="errors[`choice${index}`]" class="help is-danger">
                {{ errors[`choice${index}`] }}
              </p>
            </div>
            <div class="column is-1 field-options">
              <i
                class="fa fa-plus-square-o mr1 pointer"
                @click="addField(index)"
              ></i>
              <i
                class="fa fa-minus-square-o pointer"
                v-if="index > 1"
                @click="removeField(index)"
              ></i>
              <i
                class="fa fa-minus-square-o has-text-grey-light"
                v-if="index <= 1"
              ></i>
            </div>
          </div>
        </div>
        <RoutingRules
          v-model="data.routingRules"
          :routingMeta="routingMeta"
          :question="data"
        />
        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button type="button" class="button is-link" @click="hideEdit()">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move
      v-if="mover"
      :question="question"
      @hide="hideMove"
    ></question-move>
    <question-type
      v-if="typer"
      :question="question"
      @hide="hideTyper"
    ></question-type>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import RoutingRules from "../routing_rules/RoutingRules";

export default {
  name: "multitext",
  components: {
    RoutingRules
  },
  mixins: [baseQuestion],

  methods: {
    addField(index) {
      this.data.fields.splice(index + 1, 0, { choice: "" });
    },

    removeField(index) {
      this.data.fields.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.field-options {
  align-self: center;
  justify-content: center;
}
</style>
